import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { configureApi } from './api/client';
import { useAuthStore } from './auth/authStore';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Clientes } from './pages/Clientes';
import { Empleados } from './pages/Empleados';
import { Servicios } from './pages/Servicios';
import { Refacciones } from './pages/Refacciones';
import { Relaciones } from './pages/Relaciones';
import { NuevaRelacion } from './pages/NuevaRelacion';
import { Facturas } from './pages/Facturas';
import { Sync } from './pages/Sync';
import { SoporteDiario } from './pages/SoporteDiario';

export default function App() {
  const token = useAuthStore((s) => s.token);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    configureApi({
      tokenProvider: () => useAuthStore.getState().token,
      unauthorizedHandler: () => logout(),
    });
  }, [logout]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="clientes" element={<ProtectedRoute roles={['Admin', 'Operador']}><Clientes /></ProtectedRoute>} />
          <Route path="empleados" element={<ProtectedRoute roles={['Admin', 'Operador']}><Empleados /></ProtectedRoute>} />
          <Route path="servicios" element={<ProtectedRoute roles={['Admin', 'Operador']}><Servicios /></ProtectedRoute>} />
          <Route path="refacciones" element={<ProtectedRoute roles={['Admin', 'Operador']}><Refacciones /></ProtectedRoute>} />
          <Route path="soporte-diario" element={<ProtectedRoute roles={['Admin', 'Operador']}><SoporteDiario /></ProtectedRoute>} />
          <Route path="relaciones" element={<ProtectedRoute roles={['Admin', 'Operador']}><Relaciones /></ProtectedRoute>} />
          <Route path="relaciones/nueva" element={<ProtectedRoute roles={['Admin', 'Operador']}><NuevaRelacion /></ProtectedRoute>} />
          <Route path="facturas" element={<ProtectedRoute roles={['Admin', 'Operador']}><Facturas /></ProtectedRoute>} />
          <Route path="sync" element={<ProtectedRoute roles={['Admin', 'Operador']}><Sync /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
